import React from "react";
import noEquityArt from "../../assets/property-loan/property-no-equity.svg";

export default function PropertyLoanNoEquity({
  value,
  mortgage,
  cpf,
  ltv,
  onEdit,
  formatMoney,
}) {
  const limit = value * ltv;
  const total = mortgage + cpf;
  return (
    <>
      <section className="pl-no-equity">
        <img className="pl-no-equity-icon" src={noEquityArt} alt="" />
        <h2>Sorry, your property isn't eligible for a cash-out right now</h2>
        <p>
          Your outstanding mortgage and CPF housing usage reach the estimated
          lending limit for your property.
        </p>
      </section>
      <section className="pl-shortfall" aria-labelledby="pl-shortfall-heading">
        <h4 id="pl-shortfall-heading">How did we work this out?</h4>
        <p>
          Your outstanding loan and CPF housing usage use up the available
          lending amount.
        </p>
        <div className="pl-equity-gauge" aria-hidden="true">
          <span
            style={{ width: `${Math.min(100, (mortgage / value) * 100)}%` }}
          />
          <span style={{ width: `${Math.min(100, (cpf / value) * 100)}%` }} />
          <i style={{ left: `${ltv * 100}%` }}>
            <em>{ltv * 100}% limit</em>
          </i>
        </div>
        <div className="pl-gauge-legend">
          <span>
            Outstanding loan <b>{formatMoney(mortgage)}</b>
          </span>
          <span>
            CPF housing usage <b>{formatMoney(cpf)}</b>
          </span>
        </div>
        {[
          ["Estimated valuation", value],
          [`Maximum lending at ${ltv * 100}% LTV`, limit],
          ["Outstanding loan + CPF usage", total],
          ["Shortfall", Math.max(0, total - limit)],
        ].map(([label, amount]) => (
          <div className="pl-calculation-row" key={label}>
            <span>{label}</span>
            <b>{formatMoney(amount)}</b>
          </div>
        ))}
      </section>
      <section className="pl-relationship-review">
        <div>
          <h3>Fret not. This isn't the final word.</h3>
          <p>
            Our instant check uses standard limits. A Relationship Manager can
            look deeper at your situation:
          </p>
          <ul>
            <li>
              <b>A lender's own valuation</b> may come in higher than our
              estimate.
            </li>
            <li>
              <b>Other options</b>, such as business or corporate financing, may
              fit you better.
            </li>
            <li>
              <b>Your full picture</b>, including other assets and income, can
              change what's possible.
            </li>
          </ul>
          <div className="pl-actions">
            <a className="pl-primary" href="/contactus">
              Talk to a Relationship Manager
            </a>
            <button type="button" className="pl-back" onClick={onEdit}>
              ← Edit my details
            </button>
          </div>
        </div>
        <div className="pl-relationship-profile">
          <div>RM</div>
          <b>Your SmartLend Relationship Manager</b>
          <small>Mon–Fri, 9am–6pm · Free, no-obligation review</small>
        </div>
      </section>
    </>
  );
}
